export default class Loader {
  getLoader() {
    return '<div class="loader" style="width: 100%; height: 100px;">' +
      '<div class="sk-three-bounce">' +
      '<div class="sk-bounce1"></div>' +
      '<div class="sk-bounce2"></div>' +
      '<div class="sk-bounce3"></div>' +
      '</div>' +
      '</div>';
  }
}



// WEBPACK FOOTER //
// ./_common/scripts/loader.js